import Route from '@ember/routing/route';

import { set } from '@ember/object';

export default class GiftRoute extends Route {
  setupController(controller, model) {
    super.setupController(controller, model);
    var application = this.controllerFor('application');
    set(application, 'showCart', null);
    set(application, 'showMenu', null);

    controller.set('paymentAPI', null);
    // Clear the previously-chosen gift product so a repeat gift purchase does not
    // inherit the prior selection (maint 5.6 leak fix).
    controller.set('giftSelected', null);
    controller.set('gift_message', null);
    controller.set('gift_style', null);
  }
}
